import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';
import { createEmpresaModel } from '../utils/empresaUtils';

// idb store name
const storeName = 'empresas';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configPedidos');
const host = configLocal ? JSON.parse(configLocal).host : '';
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const endpoint = 'empresa';
// const sqlEmpresa = 23;

export const empresaService = {
  getEmpresa,
  getEmpresas,
  getEmpresasAPI,
  getEmpresaAPI,
  addEmpresa,
  addEmpresas,
  compareAndUpdateEmpresa
};

function getEmpresas() {
  return getIndexedDBEmpresas();
}

function getIndexedDBEmpresas() {
  return idbService.getAll(storeName);
}

async function getEmpresasAPI() {
  try {
    const response = await apiRequest.post(`${baseURL}/${endpoint}`, {
      campos: [
        "id_empresa",
        "razao_social",
        "nome_fantasia",
        "apelido",
        "cpf_cnpj",
        "inscricao_estadual",
        "inscricao_municipal",
        "endereco",
        "numero_endereco",
        "complemento",
        "bairro",
        "cidade",
        "cep",
        "site",
        "email",
        "telefone"
      ]
    }, {
      params: {
        Acao: 'lista'
      }
    });
    const empresasApi = environment === 'production' ? response.data.result || [] : response.data || [];

    await compareAndUpdateEmpresa(empresasApi);
    return empresasApi;
  } catch (error) {
    console.log(error);
    throw new Error('Ocorreu um erro ao buscar as empresas');
  }
}

async function getEmpresaAPI(idEmpresa) {
  try {
    const response = await apiRequest.get(`${baseURL}/${endpoint}/${idEmpresa}`);
    const empresaApi = environment === 'production' ? response.data.result : response.data;
    await updateEmpresa(empresaApi);
    // console.log('empresaApi', empresaApi);
    return getEmpresa(idEmpresa);
  } catch (error) {
    console.log(error);
    throw new Error('Ocorreu um erro ao buscar a empresa');
  }
}

function getEmpresa(id) {
  return idbService.getById(storeName, id);
}

async function addEmpresa(empresa) {
  const parsedEmpresa = createEmpresaModel(empresa);
  return idbService.addToStore(storeName, parsedEmpresa);
}

async function addEmpresas(empresas = []) {
  const parsedEmpresas = empresas.map(empresa => createEmpresaModel(empresa));
  return idbService.addMultipleToStore(storeName, parsedEmpresas);
}

async function updateEmpresa(empresa) {
  const parsedEmpresa = createEmpresaModel(empresa);
  await idbService.updateItem(storeName, parsedEmpresa);
}

async function compareAndUpdateEmpresa(empresas) {
  if (empresas && empresas.length) {
    for (const empresa of empresas) {
      const savedEmpresa = await getEmpresa(empresa.id_empresa);
    
      if (!savedEmpresa) {
        empresa.versao_imp = 1;
        await addEmpresa(empresa);
      } else {
        empresa.versao_imp = savedEmpresa.versao_imp ? savedEmpresa.versao_imp + 1 : 1;
        await updateEmpresa(empresa);
      }
    }
  } else {
    // Limpa os registros do store empresas
    await idbService.clearStore(storeName);
  }
}